module.exports = __webpack_public_path__ + "catalog/items/transparent-base-unit/Transparent-base-unit.svg";